module.exports = __webpack_public_path__ + "media/notify-alert.0b226a5b.wav";